var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_338_143329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_338_143329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41667 12.75C3.09583 12.75 2.82118 12.6358 2.59271 12.4073C2.36424 12.1788 2.25 11.9042 2.25 11.5833V3.41667C2.25 3.09583 2.36424 2.82118 2.59271 2.59271C2.82118 2.36424 3.09583 2.25 3.41667 2.25H7.5V3.41667H3.41667V11.5833H7.5V12.75H3.41667ZM9.83333 10.4167L9.03125 9.57083L10.5188 8.08333H5.75V6.91667H10.5188L9.03125 5.42917L9.83333 4.58333L12.75 7.5L9.83333 10.4167Z",
    fill: "#1E1C1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7fb49d104cf3aff32458d40f912789ac.svg";
export { ForwardRef as ReactComponent };